import useExperimentCustom from './useExperimentCustom';

const useExperimentCtaUrl = (): string => {
  const experimentResult = useExperimentCustom([
    {
      experiment: 'artemis_request_a_call_form',
      default: false,
      getter: 'enabled',
    },
  ]);

  const isVariant = experimentResult.enabled.value;
  return isVariant ? 'https://discovery.helloartemis.com/mightynetworks' : '/request-a-call-form';
};

export default useExperimentCtaUrl;
